"use client"

import { useApp } from "@/lib/context"
import Notification from "./notification"

export default function NotificationContainer() {
  const { notification, hideNotification } = useApp()

  const shouldShow =
    notification.isVisible && notification.message && notification.message.trim() !== ""

  return (
    <>
      {shouldShow && (
        <Notification
          message={notification.message}
          isVisible={notification.isVisible}
          onClose={hideNotification}
        />
      )}
    </>
  )
}
